import ApiInfo from "./ApiInfo";
import { connect } from "react-redux";
import { actions } from "./apiAdminActions";

export default connect(
  state => ({ apiInfo: state.apiAdmin }),
  actions
)(ApiInfo);
